<sf-card class="smartquote-details">
    <ng-container [formGroup]="form">
        @let statistics = smartquoteHelperService.statistics();
        <div class="details-overview details-fields">
            <div class="details-column">
                <section class="details-section details-customer">
                    <sf-input
                        inlineLabel
                        compact
                        labelWidth="var(--details-label-width, 7rem)"
                        label="Customer"
                        inputId="customer"
                        formControlName="customerName"></sf-input>
                    <sf-input
                        inlineLabel
                        compact
                        labelWidth="var(--details-label-width, 7rem)"
                        label="Email"
                        inputId="email"
                        formControlName="emailAddress"></sf-input>
                    @if (existingWorkAddress()) {
                        <sf-input-textarea
                            inlineLabel
                            compact
                            labelWidth="var(--details-label-width, 7rem)"
                            label="Work Address"
                            inputId="workAddress"
                            [rows]="2"
                            [maxLength]="1000"
                            formControlName="workAddress" />
                    } @else {
                        <sf-postcode-lookup
                            inlineLabel
                            compact
                            labelWidth="var(--details-label-width, 7rem)"
                            label="Postcode"
                            inputId="postcode"
                            formControlName="postcode"
                            (onAddressChange)="selectAddress($event)" />
                        <sf-input
                            inlineLabel
                            compact
                            labelWidth="var(--details-label-width, 7rem)"
                            label="Address Line 1"
                            inputId="addressLine1"
                            formControlName="addressLine1"></sf-input>
                        <sf-input
                            inlineLabel
                            compact
                            labelWidth="var(--details-label-width, 7rem)"
                            label="Address Line 2"
                            inputId="addressLine2"
                            formControlName="addressLine2"></sf-input>
                        <sf-input
                            inlineLabel
                            compact
                            labelWidth="var(--details-label-width, 7rem)"
                            label="Town"
                            inputId="town"
                            formControlName="town"></sf-input>
                        <sf-input
                            inlineLabel
                            compact
                            labelWidth="var(--details-label-width, 7rem)"
                            label="County"
                            inputId="county"
                            formControlName="county"></sf-input>
                    }
                </section>
                <section class="details-section details-job">
                    <div class="details-field-row">
                        <sf-label
                            inline
                            compact
                            description="select a predefined job template to prefill the job description"
                            for="jobType"
                            label="Job template"></sf-label>
                        <ng-select
                            id="jobType"
                            placeholder="Select template"
                            [items]="smartQuoteTemplates()"
                            bindValue="id"
                            bindLabel="name"
                            (change)="onJobTypeChange($event)">
                        </ng-select>
                    </div>
                    <sf-input-textarea-ai
                        inlineLabel
                        compact
                        labelWidth="var(--details-label-width, 7rem)"
                        description="Shown to the customer on the acceptance page"
                        label="Job Description"
                        inputId="notes"
                        [maxLength]="2000"
                        [rows]="2"
                        aiInstructions="Rewrite this job description to make it more appealing to the customer"
                        formControlName="notes">
                    </sf-input-textarea-ai>

                    <sf-input-textarea-ai
                        inlineLabel
                        compact
                        labelWidth="var(--details-label-width, 7rem)"
                        description="Internal notes, not shown to the customer"
                        label="Staff Notes"
                        inputId="staffNotes"
                        [maxLength]="2000"
                        [rows]="2"
                        aiInstructions="Rewrite these internal notes for office staff, these notes will not be visible to the customer"
                        formControlName="staffNotes"></sf-input-textarea-ai>

                    <sf-input-textarea-ai
                        inlineLabel
                        compact
                        labelWidth="var(--details-label-width, 7rem)"
                        description="Internal notes, not shown to the customer, visible to engineer on app"
                        label="Engineer Notes"
                        inputId="engineerNotes"
                        [maxLength]="2000"
                        [rows]="2"
                        aiInstructions="Rewrite these internal notes for field engineers, these notes will not be visible to the customer"
                        formControlName="engineerNotes"></sf-input-textarea-ai>
                </section>
            </div>
            <div class="details-column">
                <section class="details-section details-costs" aria-labelledby="quote-summary-heading">
                    <div class="col-12 d-flex flex-wrap gap-1 mb-2">
                        <button
                            sfButton
                            color="primary"
                            size="sm"
                            tooltip="If enabled, the quote PDF will show price of £0.00."
                            tooltipContainer="body"
                            [icon]="form.get('freeOfCharge')?.value ? 'check-circle' : 'xmark-circle'"
                            [active]="form.get('freeOfCharge')?.value"
                            (click)="toggleFreeOfCharge()">
                            Free of Charge
                        </button>
                        <button
                            sfButton
                            color="primary"
                            size="sm"
                            tooltip="If enabled, the quote PDF will not show parts seperately. Parts & labour will be combined into a single line."
                            tooltipContainer="body"
                            [icon]="form.get('combinedLines')?.value ? 'check-circle' : 'xmark-circle'"
                            [active]="form.get('combinedLines')?.value"
                            (click)="toggleCombinedLines()">
                            Combined Parts & Labour
                        </button>
                        @if (form.get('freeOfCharge')?.value) {
                            <p class="small fw-bold text-danger mb-0 mt-1">
                                This quote is marked as Free of Charge. The customer will not be charged for this work.
                            </p>
                        }
                    </div>
                    <div class="details-cost-fields">
                        <div class="details-field-row">
                            <sf-label inline compact for="summaryParts" label="Parts"></sf-label>
                            <input
                                id="summaryParts"
                                class="form-control form-control-sm details-calculated-input"
                                type="text"
                                [value]="statistics.linesTotal | currency"
                                readonly />
                        </div>
                        @if (statistics.linesTermsTotal) {
                            <div class="details-field-row">
                                <sf-label
                                    inline
                                    compact
                                    for="summaryPartsTerms"
                                    label="-- Parts (Wolseley Terms)"></sf-label>
                                <input
                                    id="summaryPartsTerms"
                                    class="form-control form-control-sm details-calculated-input text-success"
                                    type="text"
                                    [value]="statistics.linesTermsTotal | currency"
                                    readonly />
                            </div>
                        }
                        <div class="details-labour-row">
                            <div class="details-field-row">
                                <sf-label inline compact for="labourHours" label="Labour Hours"></sf-label>
                                <ng-select
                                    id="labourHours"
                                    [items]="smartquoteHelperService.labourHours"
                                    [clearable]="false"
                                    formControlName="labourHours">
                                    <ng-template ng-option-tmp let-item="item"> {{ item }} </ng-template>
                                </ng-select>
                            </div>
                            <sf-input-money
                                inlineLabel
                                compact
                                labelWidth="var(--details-label-width, 7rem)"
                                label="Labour Rate"
                                inputId="labourRate"
                                formControlName="labourRate"></sf-input-money>
                        </div>
                        <div class="details-field-row">
                            <sf-label inline compact for="summaryLabour" label="Labour"></sf-label>
                            <input
                                id="summaryLabour"
                                class="form-control form-control-sm details-calculated-input"
                                type="text"
                                [value]="statistics.labourCost | currency"
                                readonly />
                        </div>
                        <div class="row gx-2">
                            <div class="col-12">
                                <div class="details-field-row">
                                    <sf-label inline compact for="discountPercentage" label="Discount %"></sf-label>
                                    <ng-select
                                        [items]="smartquoteHelperService.discountPercentages"
                                        [clearable]="false"
                                        formControlName="discountPercentage">
                                        <ng-template ng-label-tmp let-item="item"> {{ item }}% </ng-template>
                                        <ng-template ng-option-tmp let-item="item"> {{ item }}% </ng-template>
                                    </ng-select>
                                </div>
                                <div>
                                    <sf-input-money
                                        inlineLabel
                                        compact
                                        labelWidth="var(--details-label-width, 7rem)"
                                        label="Discount (exc. VAT)"
                                        inputId="moneyOff"
                                        formControlName="moneyOff"></sf-input-money>
                                </div>
                                <div class="details-field-row">
                                    <sf-label inline compact for="summaryDiscount" label="Discount"></sf-label>
                                    <input
                                        id="summaryDiscount"
                                        class="form-control form-control-sm details-calculated-input"
                                        type="text"
                                        [value]="
                                            statistics.discountAsPercentage + statistics.discountAsMoney | currency
                                        "
                                        readonly />
                                </div>
                                <div class="details-field-row">
                                    <sf-label inline compact for="summarySubtotal" label="Subtotal"></sf-label>
                                    <input
                                        id="summarySubtotal"
                                        class="form-control form-control-sm details-calculated-input"
                                        type="text"
                                        [value]="statistics.totalExcludeVat | currency"
                                        readonly />
                                </div>
                                <div class="details-field-row">
                                    <sf-label
                                        inline
                                        compact
                                        for="vatPercentage"
                                        label="VAT Rate"
                                        [required]="true"></sf-label>
                                    <ng-select
                                        id="vatPercentage"
                                        [items]="smartquoteHelperService.vatPercentages"
                                        [clearable]="false"
                                        bindLabel="display"
                                        bindValue="value"
                                        formControlName="vatMultiplier">
                                    </ng-select>
                                </div>
                                <div class="details-field-row">
                                    <sf-label inline compact for="summaryVat" label="VAT"></sf-label>
                                    <input
                                        id="summaryVat"
                                        class="form-control form-control-sm details-calculated-input"
                                        type="text"
                                        [value]="statistics.totalVat | currency"
                                        readonly />
                                </div>
                                <div class="details-field-row details-summary-total">
                                    <sf-label inline compact for="summaryTotal" label="Total"></sf-label>
                                    <input
                                        id="summaryTotal"
                                        class="form-control form-control-sm details-calculated-input fw-bold"
                                        type="text"
                                        [class.text-decoration-line-through]="form.get('freeOfCharge')?.value"
                                        [value]="statistics.totalIncludeVat | currency"
                                        readonly />
                                </div>
                                <div class="details-field-row">
                                    <sf-label inline compact for="Deposit" label="Deposit"></sf-label>
                                    <ng-select
                                        [items]="smartquoteHelperService.depositPercentages"
                                        formControlName="depositPercentage">
                                        <ng-template ng-label-tmp let-item="item"> {{ item }}% </ng-template>
                                        <ng-template ng-option-tmp let-item="item"> {{ item }}% </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="details-image-row">
                            <div>
                                <sf-input
                                    inlineLabel
                                    compact
                                    labelWidth="var(--details-label-width, 7rem)"
                                    description="This image will be used on the 'Landing Page' seen by the customer. When adding a part from the catalog and if the part has an image, click the image to copy the URL to this field."
                                    label="Image Url"
                                    inputId="defaultImageUrl"
                                    formControlName="defaultImageUrl"></sf-input>
                            </div>
                            @if (form.controls.defaultImageUrl.value) {
                                <div>
                                    <img class="img-fluid details-image" [src]="form.controls.defaultImageUrl.value" />
                                </div>
                            }
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div class="col-12 my-1 details-notification">
            <div class="bg-dark bg-opacity-10 px-2 py-1 rounded">
                <sf-switch
                    compact
                    description="Users with the setting 'Notify me when quote is accepted' is turned on, will receive an sms."
                    label="Notify users when quote is accepted or declined"
                    inputId="notifyUsers"
                    formControlName="notifyUsers"></sf-switch>
            </div>
        </div>

        <div class="row gx-3 px-1 py-1 details-basket">
            <div class="col-12">
                <h5>Parts</h5>
                <p class="small text-body-secondary mb-1">
                    Add parts via the catalog, Parts Arena, bespoke items or your favourites.
                </p>
                @if (gcNumber) {
                    <p class="small fw-bold text-success mb-1">
                        The customers main appliance GC Number is
                        <span class="text-decoration-underline">{{ gcNumber }}</span
                        >.
                    </p>
                }
            </div>
            <div class="col-12">
                <div class="d-flex flex-wrap gap-1 mb-2">
                    <button
                        sfButton
                        class="me-md-1"
                        size="sm"
                        color="secondary"
                        icon="magnifying-glass-plus"
                        tooltip="Search for parts in Wolseley"
                        (click)="openWolseleySearch()">
                        Catalog
                    </button>
                    <button
                        sfButton
                        class="me-md-1"
                        size="sm"
                        color="secondary"
                        icon="magnifying-glass-plus"
                        tooltip="Search for parts in Parts Arena"
                        (click)="openPartsArenaSearch()">
                        Parts Arena
                    </button>

                    <button
                        sfButton
                        class="me-md-1"
                        size="sm"
                        color="secondary"
                        icon="magnifying-glass-plus"
                        tooltip="Search for parts in your Bespoke Favourites"
                        (click)="openSmartquoteBespokeFavouriteSearch()">
                        Bespoke
                    </button>
                    <button
                        sfButton
                        class="me-md-1"
                        size="sm"
                        color="secondary"
                        icon="magnifying-glass-plus"
                        tooltip="Search for parts in your Favourites from Wolseley"
                        (click)="openSmartQuoteFavouriteSearch()">
                        Favourites
                    </button>
                </div>

                @if (lineItems.length) {
                    <div class="smartquote-line rounded bg-light mb-1 d-none d-lg-block">
                        <div class="row gx-2 px-2 py-1 small">
                            <div class="fw-bold col-lg-5">Product</div>
                            <div class="fw-bold col-lg-3">Units</div>
                            <div class="fw-bold col-lg-2">Trade Cost</div>
                            <div class="fw-bold col-lg-2 text-end">Total</div>
                        </div>
                    </div>
                }

                <div formArrayName="lineItems">
                    @for (item of lineItems.controls; track item; let i = $index) {
                        <div class="smartquote-line rounded p-2 bg-light mb-1">
                            <ng-container [formGroupName]="i">
                                <div class="row g-2">
                                    <div class="col-12 col-lg-5">
                                        <div class="d-flex">
                                            <div class="flex-fill pe-2">
                                                <div class="d-flex">
                                                    @if (item.value.imageUrl) {
                                                        <img
                                                            [src]="item.value.imageUrl"
                                                            (click)="changeDefaultImageUrl.emit(item.value.imageUrl)"
                                                            class="details-product-image me-2"
                                                            alt="Product Image" />
                                                    }
                                                    <div class="flex-fill">
                                                        <sf-input
                                                            compact
                                                            size="sm"
                                                            inputId="description-{{ i }}"
                                                            formControlName="description"></sf-input>

                                                        @if (item.value.mpn) {
                                                            <span class="small text-body-secondary d-block"
                                                                >MPN: {{ item.value.mpn }}</span
                                                            >
                                                        }
                                                        @if (item.value.catalogNumber) {
                                                            <span class="small text-body-secondary d-block"
                                                                >Product Code: {{ item.value.catalogNumber }}</span
                                                            >
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-lg-none ms-auto">
                                                <a
                                                    sfButton
                                                    color="danger"
                                                    size="sm"
                                                    tooltip="Remove part"
                                                    icon="trash"
                                                    (click)="removeLineItem(i)"></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-4 col-lg-3">
                                        <span class="d-lg-none">Quantity</span>
                                        <div class="d-flex">
                                            <div>
                                                <a
                                                    sfButton
                                                    color="danger"
                                                    size="sm"
                                                    class="d-none d-lg-inline-block me-1"
                                                    tooltip="Remove part"
                                                    icon="trash"
                                                    (click)="removeLineItem(i)"></a>
                                            </div>
                                            <div>
                                                <sf-input-quantity
                                                    compact
                                                    inputId="quantity-{{ i }}"
                                                    [min]="1"
                                                    size="sm"
                                                    formControlName="quantity"></sf-input-quantity>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-4 col-lg-2">
                                        <span class="d-lg-none">Unit Cost</span>
                                        <sf-input-money
                                            compact
                                            inputId="cost-{{ i }}"
                                            size="sm"
                                            formControlName="cost"></sf-input-money>
                                        @if (item.value.terms && item.value.cost) {
                                            <p
                                                class="mb-0 small fw-bold"
                                                [class.text-danger]="item.value.terms >= item.value.cost"
                                                [class.text-success]="
                                                    item.value.terms > 0 && item.value.terms < item.value.cost
                                                "
                                                [class.text-warning]="item.value.terms <= 0">
                                                Terms: {{ item.value.terms | currency }}
                                            </p>
                                        } @else {
                                            <p class="mb-0 small text-warning fw-bold">Could not determine terms</p>
                                        }
                                    </div>
                                    <div class="col-12 col-sm-4 col-lg-2 text-end">
                                        <p class="mb-0 fw-bold">
                                            <span class="d-lg-none">Line Total: </span
                                            >{{ item.value.cost! * item.value.quantity! | currency }}
                                        </p>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    }
                </div>
            </div>
        </div>
    </ng-container>
</sf-card>
